// https://swiperjs.com/api/#custom-build
import { Autoplay, Swiper, EffectCoverflow, Navigation, Pagination } from 'swiper';

let currentHomeSliderBullet: Element | undefined;
const currentlyVisibleSlides: Record<string, NodeListOf<Element> | null> = {
    '.home-slider': null,
    '.grant-branch-slider': null
};

let homeSwiper: Swiper | null;
const pauseButton = document.querySelector<HTMLElement>('.swiper-button-pause');
const playButton = document.querySelector<HTMLElement>('.swiper-button-play');

function setLinkTabIndexes (sliderElement: Element, tabIndex: number): void {
    for (const link of sliderElement.querySelectorAll('a')) {
        link.tabIndex = tabIndex;
    }
}

function hideSlidesFromScreenReader (containerSelector: string): void {
    if (currentlyVisibleSlides[containerSelector]) {
        // @ts-ignore the compiler ignores the if and emits "TS2531: Object is possibly 'null'."
        for (const slide of currentlyVisibleSlides[containerSelector]) {
            setLinkTabIndexes(slide, -1);
            slide.setAttribute('aria-hidden', 'true');
        }
    }
}

function updateSlidesAccessibility (containerSelector: string, slideSelector: string): void {
    hideSlidesFromScreenReader(containerSelector);
    currentlyVisibleSlides[containerSelector] = document.querySelectorAll(`${containerSelector} ${slideSelector}`);
    // @ts-ignore the compiler ignores the if and emits "TS2531: Object is possibly 'null'."
    for (const slide of currentlyVisibleSlides[containerSelector]) {
        setLinkTabIndexes(slide, 0);
        slide.setAttribute('aria-hidden', 'false');
    }
}

function setHomeSliderBullets (): void {
    if (!currentHomeSliderBullet) {
        currentHomeSliderBullet = document.querySelector('.home-slider .swiper-pagination-bullets')?.children[0];
    }

    for (const bullet of document.querySelectorAll('.home-slider .swiper-pagination-bullet')) {
        if (bullet.classList.contains('swiper-pagination-bullet-active')) {
            currentHomeSliderBullet?.setAttribute('aria-disabled', 'false');
            bullet.setAttribute('aria-disabled', 'true');
            currentHomeSliderBullet = bullet;
        }
    }
}

function stopSliderAutoPlay (): void {
    homeSwiper?.autoplay.stop();
    if (pauseButton) {
        pauseButton.style.display = 'none';
    }
    if (playButton) {
        playButton.style.display = 'block';
    }
    for (const slide of document.querySelectorAll('.home-slider .swiper-slide')) {
        setLinkTabIndexes(slide, -1);
    }
    document.querySelector<HTMLElement>('.swiper-button-play button')?.focus();
}

function startSliderAutoPlay (): void {
    homeSwiper?.autoplay.start();
    if (pauseButton) {
        pauseButton.style.display = 'block';
    }
    if (playButton) {
        playButton.style.display = 'none';
    }
    document.querySelector<HTMLElement>('.swiper-button-pause button')?.focus();
}

export function homeSlider (): void {
    const sliderWrapper = document.querySelector<HTMLElement>('#home-swiper-wrapper');
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    homeSwiper = new Swiper('.home-slider', {
        modules: [Autoplay, EffectCoverflow, Navigation, Pagination],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        autoplay: {
            delay: 12000,
            disableOnInteraction: true
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                const disabled = index ? '' : 'aria-disabled="true"';
                let label;
                let controls = '';
                if (sliderWrapper) {
                    const slide = sliderWrapper.children[index];
                    const labelId = slide.getAttribute('aria-labelledby') || '';
                    label = `aria-labelledby="${labelId}"`;
                    controls = `aria-controls="${slide.id}"`;
                } else {
                    label = `aria-label="slide ${index + 1}"`; // dumb fallback if HTML does not match expectations
                }
                return `<button class="${className}" ${label} ${controls} ${disabled}/>`;
            }
        },
        a11y: {
            enabled: false
        },
        effect: 'coverflow',
        autoHeight: true,
        on: {
            init: function () {
                // Home slider items are regular CEs: they are initially all "visible" for screen readers
                currentlyVisibleSlides['.home-slider'] = document.querySelectorAll('.home-slider .swiper-slide');
                document.querySelectorAll('.home-slider .swiper-slide h2, .home-slider .swiper-slide .block-text').forEach(
                    (header) => header.classList.add('swiper-no-swiping')
                );
                updateSlidesAccessibility('.home-slider', '.swiper-slide-active');
            },
            transitionStart: function () {
                hideSlidesFromScreenReader('.home-slider');
            },
            transitionEnd: function () {
                updateSlidesAccessibility('.home-slider', '.swiper-slide-active');
                setHomeSliderBullets();
            }
        }
    });
    pauseButton?.addEventListener('click', function () {
        stopSliderAutoPlay();
    });
    playButton?.addEventListener('click', function () {
        startSliderAutoPlay();
    });
}

export function grantBranchSlider (): void {
    // eslint-disable-next-line no-new
    new Swiper('.grant-branch-slider', {
        modules: [Navigation, Pagination],
        loop: true,
        watchSlidesProgress: true,
        loopFillGroupWithBlank: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        a11y: {
            enabled: false
        },
        breakpoints: {
            576: {
                spaceBetween: 10,
                slidesPerGroup: 2,
                slidesPerView: 2
            },
            1024: {
                spaceBetween: 15,
                slidesPerGroup: 3,
                slidesPerView: 3
            }
        },
        on: {
            init: function () {
                updateSlidesAccessibility('.grant-branch-slider', '.swiper-slide-visible');
            },
            transitionStart: function () {
                hideSlidesFromScreenReader('.grant-branch-slider');
            },
            transitionEnd: function () {
                updateSlidesAccessibility('.grant-branch-slider', '.swiper-slide-visible');
            }
        }
    });
}
